export const USD = 'USD';
export const REWARD_IMAGE_RATIO = '43:25';
export const CROP_REWARD_IMAGE_RATIO = 43 / 25;
